<template>
  <div class="my-register-page">
    <div class="my-container">
      <b-row class="mb-2">
        <b-col sm="12" lg="8">
          <h1>{{ $t("inspectionbook") }}</h1>
        </b-col>
        <b-col class="mt-4" style="text-align:right">
          <b-button
            style="width:120px"
            variant="outline-success"
            @click="CreateNew"
          >
            {{ $t("Add") }}
          </b-button>
        </b-col>
      </b-row>

      <b-table-simple bordered>
        <b-thead>
          <b-tr variant="primary">
            <b-th style="vertical-align: middle">
              {{ $t("docNumber") }}
            </b-th>

            <b-th style="vertical-align: middle">
              {{ $t("checkDate") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("checkCoverageDate") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("orderedOrganization") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("inspectionOrganization") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("status") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("actions") }}
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(item, index) in Requests" :key="index">
            <b-td class="text-nowrap" style="vertical-align: middle">
              {{ item.requestDocNumber }}
            </b-td>

            <b-td style="white-space:nowrap">
              {{ item.startDate }} - {{ item.endDate }} ({{
                item.checkDaysNumber
              }}
              {{ $t("day") }} )
            </b-td>
            <b-td style="white-space:nowrap">
              {{ item.checkCoverageStartDate }} -
              {{ item.checkCoverageEndDate }}
            </b-td>
            <b-td>
              {{ item.orderedOrganization }}
            </b-td>
            <b-td>
              {{ item.inspectionOrganization }}
            </b-td>
            <b-td>
              {{ item.status }}
            </b-td>
            <b-td style="vertical-align: middle; text-align: center">
              <b-icon-eye-fill
                v-b-tooltip.hover
                :title="$t('view')"
                @click="Get(item)"
                style="cursor: pointer;margin-right:5px"
              ></b-icon-eye-fill>
              <b-icon
                v-b-tooltip.hover
                :title="$t('send')"
                icon="cursor"
                @click="Send(item)"
                style="cursor: pointer"
              ></b-icon>
            </b-td>
          </b-tr>
          <b-tr v-if="Requests.length === 0">
            <b-td colspan="7" class="text-center" style="padding:20px">
              {{ $t("noData") || "—" }}
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <div>
        <b-pagination
          v-model="filter.page"
          :total-rows="filter.totalRows"
          :per-page="filter.pageSize"
          first-number
          last-number
          @input="Refresh"
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <b-icon icon="chevron-double-left" size="18" />
          </template>
          <template #next-text>
            <b-icon icon="chevron-double-right" size="18" />
          </template>
        </b-pagination>
      </div>

      <b-modal
        hide-footer
        hide-header
        no-close-on-backdrop
        v-model="modal"
      >
        <p>{{ $t("send") }}</p>
        <h5>{{ $t("wantSend") }}</h5>
        <b-row class="mt-2">
          <b-col class="text-end">
            <b-button
              style="margin-right : 5px"
              variant="outline-danger"
              @click="BackModal"
            >
              {{ $t("no") }}
            </b-button>
            <b-button
              class="ml-2"
              variant="outline-success"
              @click="SendFunction"
            >
              <b-spinner
                style="margin-left : 20px"
                v-if="isSave"
                small
              ></b-spinner>
              {{ $t("yes") }}
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
    </div>
  </div>
</template>

<script>
import InspectionBookNewService from "@/services/inspectionbooknew.service";
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BIconEyeFill,
  BPagination,
} from "bootstrap-vue";
export default {
  data() {
    return {
      Requests: [],
      modal: false,
      isSave: false,
      selectedItem: null,
      filter: {
        page: 1,
        pageSize: 20,
        totalRows: 1,
      },
    };
  },
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BTableSimple,
    BIconEyeFill,
    BPagination,
  },
  created() {
    this.Refresh();
  },
  methods: {
    Refresh() {
      InspectionBookNewService.GetList(this.filter)
        .then((res) => {
          this.Requests = res.data.rows || [];
          this.filter.totalRows = res.data.total || 0;
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            this.makeToast(error.response.data, "error");
          }
        });
    },
    CreateNew() {
      this.$router.push({
        name: "InspectionBookNewEdit",
        params: { id: 0 },
        query: this.$route.query.stage ? { stage: this.$route.query.stage } : {},
      });
    },
    Get(item) {
      this.$router.push({
        name: "InspectionBookNewEdit",
        params: { id: item.id },
      });
    },
    BackModal() {
      this.modal = false;
      this.selectedItem = null;
    },
    Send(item) {
      this.selectedItem = item;
      this.modal = true;
    },
    SendFunction() {
      if (!this.selectedItem) return;
      this.isSave = true;
      InspectionBookNewService.Send({ id: this.selectedItem.id })
        .then(() => {
          this.makeToast(this.$t("SuccessSend"), "success");
          this.modal = false;
          this.selectedItem = null;
          this.Refresh();
          this.isSave = false;
        })
        .catch((error) => {
          this.makeToast(error.response.data.errors, "error");
          this.modal = false;
          this.isSave = false;
        });
    },
    makeToast(message, type) {
      var a = "";
      if (message && message.status == 500) {
        a = message.title;
      } else if (message && message.status == 400) {
        var errors = Object.values(message.errors);
        a = errors.map((el, item) => item + 1 + "." + el).join("\n");
      } else {
        a = message;
      }
      this.$toast.open({
        message: a,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
  },
};
</script>

<style></style>
